export default "__VITE_ASSET__UL4NuYua7t0D8RKNuTqZ$Q__"